// Shared content constants used across the site.
// Edit here to change globally.

export const BRAND = {
  name: "BCPeabody",
  legalName: "BCPeabody Construction Services, Inc.",
  foundedYear: 2006,
};

export const CONTACT = {
  phone: "(813) 919-5548",
  phoneHref: "tel:+18139195548",
  bobEmail: "bobcarpenter@bcpeabody.com",
  email: "kimberlycarpenter@bcpeabody.com",
  mailingAddress: "1802 N Howard Ave, P.O. Box 4528, Tampa, FL 33607",
  mailingLines: ["1802 N Howard Ave", "P.O. Box 4528", "Tampa, FL 33607"],
  location: "Tampa Bay, FL",
  hours: "Monday to Friday, 8 AM to 6 PM",
  linkedin: "https://www.linkedin.com/company/bcpeabody",
};

export const LICENSES = {
  gc: "Florida Certified General Contractor CGC1515086",
  plumb: "Florida Certified Plumbing Contractor CFC1429871",
  pe: "Florida Professional Engineer PE 63780 (Robert M. Carpenter)",
  pairedLabel: "Licensed & Insured",
};
